import { RumTransportItem, RumTransportBody } from "./types";
import { getTransportBody } from "@grafana/faro-web-sdk";

export function getRumTransportBody(item: RumTransportItem[], apiKey: string | undefined): RumTransportBody {
  let body: RumTransportBody = {
    meta: {},
    xApiToken: ""
  };
  body = { ...getTransportBody(item), xApiToken: apiKey ? apiKey : "" };
  return body;
}
